import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Provider } from '../models/provider.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Patient } from '../models/patient.model';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  private whiteLabelSubject = new BehaviorSubject<boolean>(false);

  set whiteLabel(hide: boolean) {
    this.whiteLabelSubject.next(hide);
  }

  get whiteLabel$(): Observable<boolean> {
    return this.whiteLabelSubject.asObservable();
  }

  get whiteLabel(): boolean {
    const whiteLabel = !!this.whiteLabelSubject.value;
    if(whiteLabel) return whiteLabel;

    return this.whiteLabel = !!this.getProvider()?.whiteLabel;
  }

  private _provider!: Provider | null;

  private providerSubject = new Subject<Provider | null>();

  get provider$(): Observable<Provider | null> {
    return this.providerSubject.asObservable();
  }

  constructor(
    private jwtHelper: JwtHelperService,
  ) { }

  getProviderTitle(): string {
    const provider = this.getProvider();
    const patient = this.getPatient()
    return provider?.title || provider?.name || patient?.provider?.title || patient?.provider?.name;
  }

  getProviderLogo(): string {
    const provider = this.getProvider();
    const patient = this.getPatient()
    return provider?.header || provider?.registrationSelectorImage || patient?.provider?.header || patient?.provider?.registrationSelectorImage;
  }

  setProvider(provider: Provider | null){
    this._provider = provider;
    if (provider) localStorage.setItem('provider', JSON.stringify(provider));
    else localStorage.removeItem('provider');
    this.whiteLabel = !!provider?.whiteLabel;
    this.providerSubject.next(provider);
  }

  getProvider() {
    if(this._provider) return this._provider;

    const provider = localStorage.getItem('provider');
    if (provider) {
      this.setProvider(JSON.parse(provider));
      return JSON.parse(provider);
    }
    const patient = this.getPatient()
    if (patient && patient.provider) {
      this.setProvider(patient.provider);
      return patient.provider;
    }
    return "";
  }

  clearProvider(): void {
    this.setProvider(null);
  }

  setPatient(patient:any){
    localStorage.setItem('patient', JSON.stringify(patient));
  }

  getPatient(){
    const patient = localStorage.getItem('patient');
    return patient ? JSON.parse(localStorage.getItem('patient')!) : "";
  }

  updatePatient(updateBody: Partial<Patient>){
    const patient = localStorage.getItem('patient');
    if (!patient) return;
    let parsedPatient = JSON.parse(localStorage.getItem('patient')!);
    parsedPatient = {... parsedPatient, ...updateBody}
    localStorage.setItem('patient', JSON.stringify(parsedPatient));
  }

  setRefreshData(code:string, redirectUri:string) {
    localStorage.setItem('refreshData', JSON.stringify({code, redirectUri}));
  }

  getRefreshData() {
    const refreshData = localStorage.getItem('refreshData');
    return refreshData ? JSON.parse(refreshData) : null;
  }

  cleanData(){
    localStorage.removeItem('patient')
    localStorage.removeItem('refreshData')
  }

  private isAuthenticated(): boolean {
    const token = localStorage.getItem('id_token');
    if (!token || token === 'undefined') return false;
    return !this.jwtHelper.isTokenExpired(token);
  }
}
